export default "__VITE_ASSET__ByKCFe90__"